export default "__VITE_ASSET__DNM6kt9V__"